import { render, staticRenderFns } from "./ModalTeamIncidentRemove.vue?vue&type=template&id=42402402&"
import script from "./ModalTeamIncidentRemove.vue?vue&type=script&lang=js&"
export * from "./ModalTeamIncidentRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports